import React, { useEffect } from 'react';
import { BottomNavigation, BottomNavigationAction, createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { Chat, Description, Help } from '@material-ui/icons';
import CropFreeIcon from '@material-ui/icons/CropFree';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import ShareIcon from "@material-ui/icons/Share";
import withStyles from '@material-ui/core/styles/withStyles';

import { styles } from './styles';
import ShareAction from "../MessagePane/ShareAction";
import withRoot from '../../../withRoot';

interface INorpacBottomNavigationProps {
	classes: any;
	bottomNav: string;
	setBottomNav: Function;
}

const theme = createMuiTheme({
	overrides: {
		MuiBottomNavigation: {
			root: {
				height: '80px'
			}
		}
	}
});

const NorpacBottomNavigation: React.FC<INorpacBottomNavigationProps> = ({ classes, bottomNav, setBottomNav }) => {
	const [value, setValue] = React.useState(2);
	const [shareOpen, setShareOpen] = React.useState(false);

	useEffect(() => {
		localStorage.setItem("slugTerm", "data");
		if (window.location.href.split('/')[3]) {
			setBottomNav('chat');
			setValue(2);
		}
	}, []);

	const handaleShare = () => {
		localStorage.setItem("slugTerm", "data");
		setShareOpen(true);
	}

	const closeShare = () => {
		setShareOpen(false);
	};

	return (
		<MuiThemeProvider theme={theme}>
			<BottomNavigation
				value={value}
				onChange={(event, newValue) => {
					setValue(newValue);
					newValue === 0 ? setBottomNav('bills') :
						newValue === 1 ? setBottomNav('help') :
							// newValue === 3 ? setBottomNav('QRCode') :
								newValue === 4 ? setBottomNav('GPS') : setBottomNav('chat');
				}}
				showLabels
				className={classes.root}
			>
				<BottomNavigationAction label="Home" icon={<Description className={classes.iconsSize} />} />
				<BottomNavigationAction label="Help" icon={<Help className={classes.iconsSize} />} />
				<BottomNavigationAction id="POP_chat" label="HoneyCode Chat" icon={<Chat className={classes.iconsSizeChat} />} />
				<BottomNavigationAction label="Share" icon={<ShareIcon className={classes.iconsSize} onClick={() => handaleShare()} />} />
				<BottomNavigationAction label="GPS" icon={<GpsFixedIcon className={classes.iconsSize} />} />
			</BottomNavigation>
			<ShareAction
				open={shareOpen}
				shareClose={() => closeShare()}
				url="https://honeycode.glossary.chat/"
				name="honeycode"
			/>
		</MuiThemeProvider>
	);
};

export default withRoot(withStyles(styles)(NorpacBottomNavigation));
